import * as joi from "joi";

export type { ValidationResult } from "joi";

export const clientDataSchema = joi.object().keys({
  clientName: joi.string().required(),
});